var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement, nothing } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { isNil, uniqueId } from 'lodash-es';
import styles from './sds-tooltip.lit.scss';
import { arrow, autoUpdate, computePosition, flip, offset, shift, } from '@floating-ui/dom';
import { convertToFloatingUi, getPlacementWithoutAlignment, getPositionClassName, shiftTooltip, } from './tooltip-position';
import { getClass, TooltipClass } from './tooltip-class';
import { sdsCustomElement } from '../utilities/custom-components';
import { hidePopover, showPopover, supportsPopoverAPI } from '../utilities/dom';
/**
 * `sds-tooltip` provides a floating tooltip that can be positioned relative to an element.
 * The `position` attribute allows customization of the tooltip's placement around the target element.
 *
 * ### Attributes
 * - `position`: Sets the placement of the tooltip.
 *
 * @tag sds-tooltip
 */
let SdsTooltip = (() => {
    var _SdsTooltip_opened_accessor_storage, _SdsTooltip__arrow_accessor_storage, _SdsTooltip__triggerSlot_accessor_storage, _SdsTooltip__container_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tooltip')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let _set_position_decorators;
    let __arrow_decorators;
    let __arrow_initializers = [];
    let __arrow_extraInitializers = [];
    let __triggerSlot_decorators;
    let __triggerSlot_initializers = [];
    let __triggerSlot_extraInitializers = [];
    let __container_decorators;
    let __container_initializers = [];
    let __container_extraInitializers = [];
    var SdsTooltip = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTooltip_opened_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _opened_initializers, false)));
            this._position = (__runInitializers(this, _opened_extraInitializers), 'top');
            _SdsTooltip__arrow_accessor_storage.set(this, __runInitializers(this, __arrow_initializers, void 0));
            this._timer = __runInitializers(this, __arrow_extraInitializers);
            _SdsTooltip__triggerSlot_accessor_storage.set(this, __runInitializers(this, __triggerSlot_initializers, void 0));
            _SdsTooltip__container_accessor_storage.set(this, (__runInitializers(this, __triggerSlot_extraInitializers), __runInitializers(this, __container_initializers, void 0)));
            this._unique = (__runInitializers(this, __container_extraInitializers), uniqueId('sds-tooltip'));
            this._tooltipOffset = 6;
            this._clearAutoPositioner = undefined;
            this.triggerChanged = () => {
                const trigger = this.getTrigger();
                if (!isNil(trigger)) {
                    trigger.setAttribute('sds-tooltip', this._unique);
                    trigger.addEventListener('mouseenter', this.tooltipOpeningHandler);
                    trigger.addEventListener('mouseleave', this.tooltipClosingTriggerHandler);
                    if (this._container) {
                        this._container.addEventListener('mouseleave', this.tooltipClosingPopoverHandler);
                    }
                }
            };
            this.tooltipClosingTriggerHandler = () => {
                // when mouse gets on popover, don't remove it
                clearTimeout(this._timer);
                this._timer = setTimeout(() => {
                    if (!this.matches(':hover')) {
                        this.opened = false;
                        this.requestUpdate();
                        this.hideTooltip();
                    }
                }, 100);
            };
            this.tooltipClosingPopoverHandler = (event) => {
                // when mouse gets on trigger, don't remove popover
                this._timer = setTimeout(() => {
                    if (event.relatedTarget !== this.getTrigger()) {
                        this.opened = false;
                        this.requestUpdate();
                        this.hideTooltip();
                    }
                }, 100);
            };
            this.tooltipOpeningHandler = () => {
                clearTimeout(this._timer);
                if (!this.opened) {
                    this._timer = setTimeout(() => {
                        void this.openTooltip();
                        this._clearAutoPositioner = autoUpdate(this.getTrigger(), this._container, () => this.updatePosition(), {
                            animationFrame: true,
                        });
                    }, 100);
                }
            };
        }
        get opened() { return __classPrivateFieldGet(this, _SdsTooltip_opened_accessor_storage, "f"); }
        set opened(value) { __classPrivateFieldSet(this, _SdsTooltip_opened_accessor_storage, value, "f"); }
        /**
         * Sets the placement of the tooltip relative to the target element.
         *
         * Possible values are:
         * - `'up'`: Positions the tooltip above the target.
         * - `'down'`: Positions the tooltip below the target.
         * - `'left'`: Positions the tooltip to the left of the target.
         * - `'right'`: Positions the tooltip to the right of the target.
         *
         * @attr {TooltipPlacement} position - The position of the tooltip.
         */
        set position(value) {
            this._position = convertToFloatingUi(value);
        }
        get _arrow() { return __classPrivateFieldGet(this, _SdsTooltip__arrow_accessor_storage, "f"); }
        set _arrow(value) { __classPrivateFieldSet(this, _SdsTooltip__arrow_accessor_storage, value, "f"); }
        get _triggerSlot() { return __classPrivateFieldGet(this, _SdsTooltip__triggerSlot_accessor_storage, "f"); }
        set _triggerSlot(value) { __classPrivateFieldSet(this, _SdsTooltip__triggerSlot_accessor_storage, value, "f"); }
        get _container() { return __classPrivateFieldGet(this, _SdsTooltip__container_accessor_storage, "f"); }
        set _container(value) { __classPrivateFieldSet(this, _SdsTooltip__container_accessor_storage, value, "f"); }
        render() {
            const supportsPopover = supportsPopoverAPI();
            return html `
            <slot name="trigger" @slotchange="${this.triggerChanged}"></slot>
            <div style="position: fixed; width: 100%; z-index: 9999;">
                <div
                    id="container"
                    popover="${supportsPopover ? 'manual' : nothing}"
                    class="sds-tooltip sds-tooltip--basic sds-tooltip__content--with-basic"
                    style="${!supportsPopover
                ? this.opened
                    ? 'display: block'
                    : 'display: none'
                : ''}"
                >
                    <div class="sds-tooltip__content">
                        <slot></slot>
                        <slot name="text"></slot>
                    </div>
                    <div id="arrow"></div>
                </div>
            </div>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            this.triggerChanged();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.hideTooltip();
            const trigger = this.getTrigger();
            if (trigger) {
                trigger.removeEventListener('mouseenter', this.tooltipOpeningHandler);
                trigger.removeEventListener('mouseleave', this.tooltipClosingTriggerHandler);
            }
            if (this._container) {
                this._container.removeEventListener('mouseleave', this.tooltipClosingPopoverHandler);
            }
        }
        updatePosition() {
            computePosition(this.getTrigger(), this._container, {
                placement: this._position,
                middleware: [
                    offset(7),
                    flip({
                        fallbackAxisSideDirection: 'start',
                        crossAxis: false,
                        boundary: [],
                    }),
                    shift({ boundary: [] }),
                    arrow({ element: this._arrow }),
                ],
            }).then(({ x, y, placement, middlewareData }) => {
                this._container.style.transform = `translate(${x}px, ${y}px)`;
                this.clearTooltipClasses();
                this._container.classList.add(this.getTooltipPositionClass(placement, middlewareData));
                const triggerRect = this.getTrigger().getBoundingClientRect();
                const tooltipShiftAmount = shiftTooltip(this._container.getBoundingClientRect(), getPositionClassName(placement, middlewareData), triggerRect, x, y, this._tooltipOffset);
                if (tooltipShiftAmount.translateString) {
                    this._container.style.transform = tooltipShiftAmount.translateString;
                }
                this.positionArrow(placement, triggerRect, middlewareData, {
                    x: tooltipShiftAmount.x,
                    y: tooltipShiftAmount.y,
                });
            }, e => console.error(e));
        }
        clearTooltipClasses() {
            this._container.className = TooltipClass.MAIN;
            this._container.classList.add(TooltipClass.BASIC);
        }
        positionArrow(placement, triggerRect, middlewareData, tooltipShiftAmount) {
            var _a, _b, _c, _d;
            const side = getPlacementWithoutAlignment(placement);
            const staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[side];
            if ((triggerRect.width <= 40 && (side === 'top' || side === 'bottom')) ||
                (triggerRect.height <= 40 && (side === 'left' || side === 'right'))) {
                if (staticSide) {
                    this.addSmallTriggerClass();
                    this._arrow.className = 'sds-tooltip__arrow';
                    this._arrow.style.display = '';
                    this._arrow.style.left =
                        ((_a = middlewareData.arrow) === null || _a === void 0 ? void 0 : _a.x) != null
                            ? `${((_b = middlewareData.arrow) === null || _b === void 0 ? void 0 : _b.x) - tooltipShiftAmount.x}px`
                            : '';
                    this._arrow.style.top =
                        ((_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.y) != null
                            ? `${((_d = middlewareData.arrow) === null || _d === void 0 ? void 0 : _d.y) - tooltipShiftAmount.y}px`
                            : '';
                    this._arrow.style[staticSide] = `${-this._arrow.offsetWidth / 2}px`;
                }
            }
            else if ((triggerRect.width > 40 && (side === 'top' || side === 'bottom')) ||
                (triggerRect.height > 40 && (side === 'left' || side === 'right'))) {
                this.removeSmallTriggerClass();
                this._arrow.style.display = 'none';
            }
        }
        hideTooltip() {
            if (this._clearAutoPositioner) {
                this._clearAutoPositioner();
            }
            clearTimeout(this._timer);
            hidePopover(this._container);
            this.opened = false;
        }
        getTooltipPositionClass(placement, middlewareData) {
            return getClass(getPositionClassName(placement, middlewareData));
        }
        addSmallTriggerClass() {
            this._container.classList.add('sds-tooltip--with-small-trigger');
        }
        removeSmallTriggerClass() {
            this._container.classList.remove('sds-tooltip--with-small-trigger');
        }
        openTooltip() {
            this.opened = true;
            if (this._container) {
                showPopover(this._container);
            }
        }
        getTrigger() {
            return this._triggerSlot[0];
        }
    };
    _SdsTooltip_opened_accessor_storage = new WeakMap();
    _SdsTooltip__arrow_accessor_storage = new WeakMap();
    _SdsTooltip__triggerSlot_accessor_storage = new WeakMap();
    _SdsTooltip__container_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTooltip");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _opened_decorators = [property({ type: Boolean })];
        _set_position_decorators = [property()];
        __arrow_decorators = [query('#arrow')];
        __triggerSlot_decorators = [queryAssignedElements({ slot: 'trigger' })];
        __container_decorators = [query('#container')];
        __esDecorate(_classThis, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
        __esDecorate(_classThis, null, _set_position_decorators, { kind: "setter", name: "position", static: false, private: false, access: { has: obj => "position" in obj, set: (obj, value) => { obj.position = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, __arrow_decorators, { kind: "accessor", name: "_arrow", static: false, private: false, access: { has: obj => "_arrow" in obj, get: obj => obj._arrow, set: (obj, value) => { obj._arrow = value; } }, metadata: _metadata }, __arrow_initializers, __arrow_extraInitializers);
        __esDecorate(_classThis, null, __triggerSlot_decorators, { kind: "accessor", name: "_triggerSlot", static: false, private: false, access: { has: obj => "_triggerSlot" in obj, get: obj => obj._triggerSlot, set: (obj, value) => { obj._triggerSlot = value; } }, metadata: _metadata }, __triggerSlot_initializers, __triggerSlot_extraInitializers);
        __esDecorate(_classThis, null, __container_decorators, { kind: "accessor", name: "_container", static: false, private: false, access: { has: obj => "_container" in obj, get: obj => obj._container, set: (obj, value) => { obj._container = value; } }, metadata: _metadata }, __container_initializers, __container_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTooltip = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTooltip = _classThis;
})();
export { SdsTooltip };
